import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Tab, Tabs } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useKioskNeedsActionSummary } from '../../../hooks/useKioskNeedsActionSummary';
import { KioskTransactionsList } from './KioskTransactionsList';
import { KioskNeedsActionTab } from './KioskNeedsActionTab';
import { needsActionBadgeCount } from './needsAction';

export const NEEDS_ACTION_TAB = 'needs-action';

export const KioskTransactionsPage = () => {
  const translate = useTranslate();
  const location = useLocation();
  const [tab, setTab] = useState<'all' | 'needs-action'>(new URLSearchParams(location.search).get('tab') === NEEDS_ACTION_TAB ? 'needs-action' : 'all');
  const summary = useKioskNeedsActionSummary(true);
  const count = summary === null ? 0 : needsActionBadgeCount(summary);
  const needsLabel = translate('resources.kiosk-transactions.tabs.needsAction');
  return (
    <Box>
      <Tabs value={tab} onChange={(_event, value) => setTab(value)} variant="scrollable" allowScrollButtonsMobile sx={{ px: { xs: 1, md: 2 } }}>
        <Tab value="all" label={translate('resources.kiosk-transactions.tabs.all')} />
        <Tab value="needs-action" label={count > 0 ? `${needsLabel} (${count})` : needsLabel} />
      </Tabs>
      {tab === 'all' ? <KioskTransactionsList /> : <KioskNeedsActionTab />}
    </Box>
  );
};

export default KioskTransactionsPage;
